import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";
import { useSelector } from "react-redux";
import BeautyPostCard from "../../beauty/BeautyPostCard";
import CreateBeautyPost from "../../beauty/CreateBeautyPost";

export default function BeautyFeed() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [sortBy, setSortBy] = useState("newest");
  const [showCreatePost, setShowCreatePost] = useState(false);

  useEffect(() => {
    fetchBeautyFeed();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, sortBy]);

  const fetchBeautyFeed = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/feed/beauty?page=${page}&sortBy=${sortBy}&limit=10`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      if (page === 1) {
        setPosts(response.data.data);
      } else {
        setPosts((prevPosts) => [...prevPosts, ...response.data.data]);
      }

      setHasMore(page < response.data.pagination.totalPages);
      setError(null);
    } catch (err) {
      setError("Erro ao carregar feed de beleza");
      console.error("Erro:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleNewPost = (newPost) => {
    setPosts([newPost, ...posts]);
    setShowCreatePost(false);
  };

  const handlePostUpdate = (updatedPost) => {
    setPosts(
      posts.map((post) => (post._id === updatedPost._id ? updatedPost : post))
    );
  };

  const handlePostDelete = (postId) => {
    setPosts(posts.filter((post) => post._id !== postId));
  };

  const handleLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return (
    <div className="beauty-feed-wrapper">
      <div className="beauty-feed-header-section">
        <div className="beauty-feed-title">
          <h2>💄 Beauty Feed</h2>
          <p>Tutoriais, dicas e inspiração de beleza</p>
        </div>
        <button
          className="btn-create-post-beauty"
          onClick={() => setShowCreatePost(true)}
        >
          + Criar Post
        </button>
      </div>

      <div className="beauty-feed-controls-section">
        <select
          value={sortBy}
          onChange={(e) => {
            setSortBy(e.target.value);
            setPage(1);
          }}
          className="sort-select-beauty"
        >
          <option value="newest">Mais Recentes</option>
          <option value="trending">Trending</option>
          <option value="popular">Populares</option>
        </select>
      </div>

      {showCreatePost && (
        <CreateBeautyPost
          onClose={() => setShowCreatePost(false)}
          onPostCreated={handleNewPost}
        />
      )}

      {error && <div className="error-message-beauty">{error}</div>}

      {loading && page === 1 ? (
        <div className="loading-spinner-beauty">
          <div className="spinner-beauty"></div>
          <p>Carregando posts de beleza...</p>
        </div>
      ) : posts.length > 0 ? (
        <>
          <div className="posts-grid-beauty">
            {posts.map((post) => (
              <BeautyPostCard
                key={post._id}
                post={post}
                onUpdate={handlePostUpdate}
                onDelete={handlePostDelete}
              />
            ))}
          </div>

          {hasMore && (
            <button className="load-more-btn-beauty" onClick={handleLoadMore}>
              {loading ? "Carregando..." : "Carregar mais"}
            </button>
          )}
        </>
      ) : (
        <div className="empty-state-beauty">
          <div className="empty-icon">💄</div>
          <p>Nenhum post de beleza ainda</p>
          <button onClick={() => setShowCreatePost(true)}>
            Seja o primeiro a postar
          </button>
        </div>
      )}
    </div>
  );
}
